import { theme } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { peopleActions } from 'reduxStore/people/slice';
import { Button, Flex, Modal, Typography } from 'zui/Antd';
import { ConditionalTooltipButton } from 'zui/Custom';

const { Text } = Typography;

const ResetPasswordModal = ({ data, children }) => {
	// Theme token
	const {
		token: { paddingLG, fontSizeSM, marginLG }
	} = theme.useToken();

	// Hook to dispatch actions
	const dispatch = useDispatch();

	// Selector from the redux store
	const { loadingResetPassword } = useSelector((state) => state.People);

	// Local state
	const [visible, setVisible] = useState(false);

	// Close modal function
	const handleCancel = () => {
		setVisible(false);
	};

	// Close the modal when the action is completed
	useEffect(() => {
		if (!loadingResetPassword) {
			setVisible((prev) => prev && false);
		}
	}, [loadingResetPassword]);

	return (
		<Fragment>
			<ConditionalTooltipButton
				buttonText={'Reset Password'}
				// condition={!isPermittedResetPassword}
				// disabledCondition={!isPermittedResetPassword}
				trueTitle={"You don't have permission"}
				falseTitle={'Reset Password'}
				onClick={() => setVisible(true)}
			>
				{children}
			</ConditionalTooltipButton>

			<Modal
				title={`Reset password`}
				open={visible}
				onCancel={() => handleCancel()}
				destroyOnClose={true}
				footer={[
					<Flex align='center' justify='center' style={{ marginTop: marginLG }} gap={12}>
						<Button block key='cancel' onClick={() => handleCancel()} disabled={loadingResetPassword}>
							Cancel
						</Button>
						<Button
							block
							type='primary'
							loading={loadingResetPassword}
							disabled={loadingResetPassword}
							key='delete'
							onClick={() => dispatch(peopleActions.resetPeoplePassword({ personID: data.personID }))}
						>
							Reset
						</Button>
					</Flex>
				]}
				styles={{
					content: {
						padding: `43px ${40}px ${paddingLG}px`
					}
				}}
			>
				<Text style={{ fontSize: fontSizeSM, lineHeight: '24px', textAlign: 'center' }}>
					Are you sure you want send reset password for <strong>'{data.email}'</strong>?
				</Text>
			</Modal>
		</Fragment>
	);
};

export default ResetPasswordModal;
